<template>
    <div>
        <CCard class="shadow-sm" style="">
            <CCardBody>
                <CRow>
                    <CIcon size="2xl" name="cil-basket" class="text-success col-2 col-sm-1 col-lg-1" />
                    <CCol col="7" sm="9" md="9" lg="9">
                        <select class="custom-select text-dark" v-model="shopObjectId" disabled id="shop-select">
                            <option selected>{{ $t('selectshop') }}</option>
                            <option v-for="shop in shops" :key="shop.objectId" :value="shop.objectId">
                                {{ shop.shopName }} - {{ shop.branchName }}
                            </option>
                        </select>
                    </CCol>
                    <div class="col-3 col-sm-2 col-md-2 text-right">
                        <CButton block color="light" @click="goback" class="align-items-center" id="back-button">
                            <span><i class="fi fi-rr-arrow-left mr-2"
                                    style="position: relative; top: 2px;"></i></span>{{ $t('back') }}
                        </CButton>
                    </div>
                </CRow>
            </CCardBody>
        </CCard>
        <CCard>
            <CCardBody >
                <div class="row mb-3">
                    <div class="col-md-10 col-sm-9 col-8 " >
                        <h4 class="font-weight-normal" id="editProductMultipleTitle">
                            {{ $t("addProductManagementMulti") }}
                        </h4>
                    </div>
                    <div class ="col-md-2 col-sm-3 col-4 text-right " v-if="isEditData" >
                        <CButton v-if="loadingSaveProduct" color="primary" disabled block>
                            <CSpinner  color="white" size="sm" />  {{ $t('save') }} {{$t('save')}}
                        </CButton>
                        <CButton v-else color="primary"  @click="saveProducts" block>{{$t('save')}}</CButton>
                    </div>
                </div>
                <div class="row mb-3">
                    <label class="col-sm-2 col-4 col-form-label text-left text-dark imagelabel" id="product-type-label">
                         {{ $t('itemOfProduct') }}
                    </label>
                    <div class="col-md-8">
                        <select v-model="count" class="custom-select text-dark">
                            <option v-for="index in 10" :key="index" :value="index">
                                {{ index }}
                            </option>
                        </select>
                        <span class="mb-0 text-warning">** {{ $t('addMaxProduct') }}</span>
                    </div>
                    <div class="col-md-2">
                        <CButton color="success" @click="addNewRow" block :disabled="items.length >= 10">+ {{$t('addNumberProduct')}}</CButton>
                    </div>
                    <div class=""></div>
                </div>
                <div >
                    <CAlert color="danger" :show.sync="isshowAlert" closeButton>
                        {{ $t('valtdateMember') }}
                    </CAlert>
                    <!-- <template> -->
                        <DataTable :items="items" :fields="fields" :contentMinHeight="contentMinH" id="addProductMultipleTable"   hover border
                            style="white-space: nowrap; ">
                            <!-- คอลัมน์รูปภาพ -->
                             <template #index="{item, index}">
                                <td class="text-center text-dark font-weight-normal">
                                    {{index+1}}
                                </td>
                             </template>
                            <template #img="{ item, index }">
                                <td class="text-center">
                                    <div class="display text-center" 
                                        style="width: 60px"
                                        @dragover.prevent
                                        @dragenter="dragOverIndex = index"
                                        @dragleave="dragOverIndex = null"
                                        @drop="handleDropImage(index, $event)"
                                        :class="{ dragover: dragOverIndex === index }"
                                        >
                                        <div v-if="dragUploadIndex === index" class="drag-spinner"></div>

                                        <img v-if="item.remoteImagePath" :src="item.remoteImagePath" @click="getModalImg(item, index)"
                                            class="img-fluid rd" style="border-radius: 3px" @error="noImgUrl" />
                                        <div v-else class="image-placeholder" @click="getModalImg(item, index)"
                                            :style="{ 'aspect-ratio': '4 / 3', backgroundColor: getBGColor(item.indexColor), 'border-radius': '3px' }">
                                        </div>
                                        <CSpinner
                                            v-if="uploadingImageIndexes.includes(index)"
                                            color="success"
                                            size="sm"
                                            style="position: absolute; top: 6px; left: 6px;"
                                            />
                                        <!-- <img v-if="item.remoteImagePath" :src="item.remoteImagePath" @click="getModalImg(item, index)"
                                            class="img-fluid rd" style="border-radius: 3px" @error="noImgUrl" />
                                        <div v-else class="image-placeholder" @click="getModalImg(item, index)"
                                            :style="{ 'aspect-ratio': '4 / 3', backgroundColor: getBGColor(item.indexColor), 'border-radius': '3px' }">
                                        </div> -->
                                    </div>
                                </td>
                            </template>

                            <!-- ชื่อสินค้า -->
                            <template #SKUName="{ item, index }">
                                <td>
                                    <input v-model="item.SKUName" class="form-control"
                                        style="width: 240px" 
                                        :class="{ 'is-invalid': errors[index]?.SKUName }" />
                                    <!-- <div v-if="errors[index]?.SKUName" class="invalid-feedback">
                                        {{ $t('enterProduct')}}
                                    </div> -->
                                </td>
                            </template>

                            <!-- PLU Code -->
                            <template #PLUCode="{ item, index }">
                                <td>
                                    <input v-model="item.PLUCode" class="form-control"
                                        style="width: 150px" />
                                </td>
                            </template>
                            <template #unit="{ item, index }">
                                <td class="text-center text-dark font-weight-normal">
                                    <multiselect :id="'unitSelect_' + index" v-model="item.unit" :options="unitlist" class="text-dark font-weight-normal"
                                        :search="true" :showLabels="false" :close-on-select="true"
                                        :clear-on-select="false" :placeholder="$t('selectUnit')" label="name"
                                        track-by="name"  :allow-empty="false"
                                        style="width: 170px"  :class="{ 'is-invalid': errors[index]?.unit }">
                                        
                                    </multiselect>
                                    <!-- <div v-if="errors[index]?.unit" class="invalid-feedback">
                                        กรุณากรอกหน่วยสินค้า
                                    </div> -->
                                </td>
                            </template>
                            <!-- หมวดหมู่ -->
                            <template #category="{ item, index }">
                                <td >
                                    <div :class="{ 'invalid': errors[index]?.category }">
                                    <multiselect v-model="item.category" :options="categoryList" label="name"
                                        track-by="name" style="width: 170px"  :allow-empty="false" 
                                        selectLabel=""  selectedLabel="" deselectLabel=""/>
                                        <!-- <div v-if="errors[index]?.category" class="invalid-feedback">
                                            {{$t('validateCategoryname')}}
                                        </div> -->
                                        </div>
                                </td>
                            </template>

                            <template #isMenu="{ item, index }">
                                <td class="text-center">
                                    <div class="custom-control custom-checkbox" id="productTypeisMenuCheckbox">
                                        <input type="checkbox" class="custom-control-input success cursor" v-model="item.isMenu"
                                            :id="'isMenuCheckbox' + index"  />
                                        <label class="custom-control-label cursor" :for="'isMenuCheckbox' + index">
                                            
                                        </label>
                                    </div>
                                </td>
                            </template>
                            <template #isOnScreen="{ item, index }">
                                <td class="text-center">
                                <div class="custom-control custom-checkbox" id="productTypeIsOnScreenCheckbox">
                                    <input type="checkbox" class="custom-control-input success cursor" v-model="item.isOnScreen"
                                    :id="'isOnScreenCheckbox' + index"
                                     />
                                    <label class="custom-control-label cursor" :for="'isOnScreenCheckbox' + index">
                                    </label>
                                </div>
                                </td>
                            </template>

                            <template #favorite="{ item, index }">
                                <td class="text-center">
                                <div class="custom-control custom-checkbox" id="productTypefavoriteCheckbox">
                                    <input type="checkbox" class="custom-control-input success cursor" v-model="item.favorite"
                                    :id="'favoriteCheckbox' + index"  />
                                    <label class="custom-control-label cursor" :for="'favoriteCheckbox' + index"></label>
                                </div>
                                </td>
                            </template>
                            <template #vatType="{ item, index }">
                                <td class="text-center">
                                <div class="custom-control custom-checkbox" id="productTypenetTotalIncVAT">
                                    <input type="checkbox" class="custom-control-input success cursor" v-model="item.vatType"
                                    true-value="V" false-value="N" :id="'netTotalIncVATCheckbox' + index"
                                    />
                                    <label class="custom-control-label cursor" :for="'netTotalIncVATCheckbox' + index"></label>
                                </div>
                                </td>
                            </template>
                            <!-- ราคา -->
                            <template #price="{ item, index }">
                                <td class="text-right">
                                    <input v-model.number="item.price" type="number" class="form-control"
                                         style="width: 120px" min="0"  :class="{ 'is-invalid': errors[index]?.price }" /> 
                                        <!-- <div v-if="errors[index]?.price" class="invalid-feedback">
                                        ราคาต้องมากกว่า 0
                                    </div> -->
                                </td>
                            </template>
                            <!-- <template #stdCost="{ item, index }">
                                <td class="text-center">
                                <input :id="'costInput_' + index" v-model.number="item.stdCost" min="0"
                                    @input="updateItem(index, 'stdCost', item.stdCost)" type="number" class="form-control"
                                    style="width: 120px" />
                                </td>
                            </template> -->
                            <template #description="{ item, index }">
                                <td class="text-left">
                                    <textarea :id="'desInput_' + index" v-model="item.description" class="form-control" style="width: 400px"
                                        rows="1"   :placeholder="$t('fillProductDetail')"></textarea>
                                </td>
                            </template>
                            <template #skuType="{ item, index }">
                                <td class="text-right">
                                    <select class="custom-select" v-model="item.skuType" id="product-type-select"
                                        style="width: 120px">
                                        <option value="P" selected>
                                            {{ $t('productTypeP') }}
                                        </option>
                                        <option value="BOM">
                                            {{ $t('productTypeBOM') }}
                                        </option>
                                        <option value="SN">{{ $t('productTypeSN') }}</option>
                                        <option value="SV">{{ $t('productTypeSV') }}</option>
                                    </select>
                                </td>
                            </template>

                            <!-- ลบแถว -->
                            <template #actions="{ index }">
                                <td class="text-center ">
                                    <CButton color="danger" @click="removeRow(index)"><i class="fi fi-rr-trash " style="position: relative; top: 2px;"></i></CButton>
                                </td>
                            </template>
                            <template #shelfLife="{ item, index }">
                                <td class="text-center">
                                <input v-model.number="item.shelfLife" class="form-control" style="width: 100px"
                                    type="number" min="0" />
                                </td>
                            </template>
                        </DataTable>

                    <!-- </template> -->
                </div>
            </CCardBody>
        </CCard>
        <CRow>
            <CModal :closeOnBackdrop="false" color="success" :show.sync="selectcolor" :title="$t('selectImg')" centered>
                <div v-if="loadingSaveimg" class="text-center">
                    <!-- <CRow>
                        <CCol md="1" sm="1" col="2" style="margin: 3px" v-for="item in colorList" :key="item.value"
                            :value="item.value">
                            <CButton v-if="indexColor === item.value"
                            style="box-shadow: 0 0 5px 5px rgb(163, 222, 194); color: white"
                            :class="{ active: indexColor === item.value }" @click="setindexcolor(item.value)"
                            :style="{ backgroundColor: item.color }">
                            <i class="fi fi-rr-check"></i>
                            </CButton>
                            <CButton v-else :style="{ backgroundColor: item.color }" :class="{ active: indexColor === item.value }"
                            @click="setindexcolor(item.value)">
                            <CIcon>
                                <i class="fas fa-square fa-2x"></i>
                            </CIcon>
                            </CButton>
                        </CCol>
                    </CRow> -->
                    <CRow class="justify-content-center align-items-center m-0">
                        <CCol v-for="item in colorList" :key="item.value" class="color-picker-col">
                        <CButton
                            :class="['color-picker-btn', { active: indexColor === item.value }]"
                            :style="{ backgroundColor: item.color }"
                            @click="setindexcolor(item.value)"
                        >
                            <i v-if="indexColor === item.value" class="fi fi-rr-check selected-icon"></i>
                        </CButton>
                        </CCol>
                    </CRow>
                    <hr /> 
                   <div class="row pr-2 pl-2">
                        <!-- <div class="col-md-6 col-6 text-left">
                            <label>{{ $t('selectImgFromPC') }}</label>
                            <input type="file" ref="fileInput" accept="image/*" @change="uploadImage" />
                        </div>
                        <div v-if="imageDataBtn.length > 0" class="col-md-6 col-6 text-right">
                            <CButton style="color: red;" @click="removeImage"> <i class="fi fi-rr-trash"></i> {{ $t('deleteImg') }}
                            </CButton>
                        </div> -->
                        <div class="col-md-12 col-12 text-left">
                            <div class="file-upload-container p-2 pr-4 pl-4 p-3">
                            <label class="custom-file-label">
                                <input type="file" ref="fileInput" accept="image/*" @change="uploadImage" />
                                <i class="fa fa-upload"></i> {{ $t('selectImgFromPC') }}
                            </label>
                            </div>
                        </div>
                        <div v-if="imageDataBtn.length > 0" class="col-md-12 text-center  mt-4">
                            <div 
                                class="drop-area"
                                @dragover.prevent
                                @drop="handleDrop"
                                >
                                <VueCropper v-if="!isUpload && !imageDataBtn.startsWith('https://firebasestorage')"
                                    :key="cropperKey"
                                    v-show="imageDataBtn" :guides="true" :aspectRatio="selectedRatio" :initialAspectRatio="selectedRatio" ref="cropper"
                                    :src="imageDataBtn" alt="Source Image" :zoomable="false" :scalable="false" :style="{ height: cropperHeight + 'px' }">
                                </VueCropper>
                                <img  v-else :src="imageDataBtn"  class="img-fluid" :style="{ height: cropperHeight + 'px' }" />
                            </div>
                        </div>
                        <div class="text-center p-3" v-if="!isUpload && !imageDataBtn.startsWith('https://firebasestorage')">
                            <div class="row align-items-center d-flex">
                                <div 
                                    class="col-auto flex-grow-1 d-flex justify-content-center"  
                                    v-for="(ratio, index) in cropRatios" 
                                    :key="index"
                                    style="padding-left: 1px; padding-right: 1px;"
                                >
                                <CButton 
                                    color="dark"
                                    class="ratio-btn w-100 text-center"
                                    :class="{ active: selectedRatio === ratio.value }"
                                    @click="setCropRatio(ratio.value)"
                                >
                                    <p class="mb-0 ml-1 mr-1">{{ ratio.label }}</p>
                                </CButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="text-center" width="100%">
                        <button class="btn" type="button" disabled style="color: darkcyan">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            {{ $t('imageUploading') }}...
                        </button>
                    </div>
                </div>
                <template #footer-wrapper>
                    <CRow class="pl-4 pr-4 pb-4">
                        <CCol>
                            <CButton block color="light" @click="cancel">
                            {{ $t('cancel') }}
                            </CButton>
                        </CCol>
                        <CCol>
                            <CButton block color="success" v-if="loadingSaveimg" @click="savecolorimg">
                            {{ $t('save') }}
                            </CButton>
                            <CButton block color="success" v-else disabled>
                            {{ $t('save') }}
                            </CButton>
                        </CCol>
                    </CRow>
                </template>
            </CModal>
        </CRow>
    </div>
</template>
<script>
import pos from "@/services/local";
import DataTable from "@/containers/DataTable";
import util from "@/util/util";
import permis from "@/util/permission";
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
import uploadImage from '@/util/uploadImage'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import mime from '@/util/mime'
export default {
    components: {
        DataTable,
        Multiselect,
        VueCropper
    },
    data() {
        return {
            items: [],
            unitlist: [],
            category: null,
            unit: null,
            categoryList: [],
            count : 5,
            errors : [],
            selectcolor : false,
            loadingSaveimg : true,
            indexColor : 1,
            selectedIndex : null,
            imageDataBtn: '',
            isUpload: true,
            itemObjectId : '',
            selectedRatio: 1, // ค่าเริ่มต้น 1:1
            cropperKey: 0,
            searchCategory : null,
            dataCategory : [],
            loadingSaveProduct : false,
            isshowAlert: 0,
            dragOverIndex: null,
            uploadingImageIndexes: [],
            dragUploadIndex: null,
            // contentMinH : calc(100vh - 300px)
        };
    },

    computed: {
        ...mapGetters(["shops", "users", "date"]),
        cropperHeight() {
            if (window.innerWidth < 480) return 200;
            if (window.innerWidth < 768) return 250;
            return 300; // ค่าเริ่มต้นสำหรับหน้าจอใหญ่
        },
        cropRatios () {
            return [
                { label: "Freeform", value: "freeform" },
                { label: "1:1", value: "1:1" },
                { label: "3:2", value: "3:2" },
                { label: "4:3", value: "4:3" },
                { label: "16:9", value: "16:9" },
                { label: "Original Ratio", value: "original" }
        ]},
        contentMinH() {
            return `calc(100vh - 400px)`;
        },
        isEditData() {
        let path = "/product";
        const value = permis.findPermissionEdit("product", path);
        return value; //&& this.editItem
        },
        shopObjectId: {
            get() {
                return this.$store.getters.shopObjectId;
            },
            set(newValue) {
                return this.$store.dispatch("setShop", newValue);
            },
        },
        uid() {
            let shop = this.shops.find((i) => i.objectId === this.shopObjectId);
            return shop.uid;
        },
        fields() {
            return [
                {
                    key: "index",
                    label : this.$i18n.t("number"),
                    _classes: "text-center font-weight-normal",
                },
                {
                    key: "img",
                    label: this.$i18n.t(""),
                    _classes: "text-center font-weight-normal",
                    //    _style: 'width:5%;'
                },
                {
                    key: "PLUCode",
                    label: this.$i18n.t("pluCode"),
                    _classes: "text-left font-weight-normal ",
                    //    _style: 'width:10%'
                },
                {
                    key: "SKUName",
                    label: this.$i18n.t("name"),
                    _classes: "text-left font-weight-normal",
                    isRequired : true
                    //    _style: 'width:30%'
                },
                {
                    key: "description",
                    label: this.$i18n.t("productDes"),
                    _classes: "text-left font-weight-normal ",
                },
                {
                    key: "category",
                    label: this.$i18n.t("category"),
                    _classes: "text-left font-weight-normal",
                    isRequired : true
                    //    _style: 'width:15%'
                },
                {
                    key: "unit",
                    label: this.$i18n.t("unit"),
                    isRequired : true,
                    _classes: "text-left font-weight-normal",
                },
                {
                    key: "price",
                    label: this.$i18n.t("price"),
                    isRequired : true,
                    _classes: "text-left font-weight-normal ",
                },
                // {
                //     key: "stdCost",
                //     label: this.$i18n.t("cost"),
                //     _classes: "text-left font-weight-normal ",
                // },
                {
                    key: "skuType",
                    isRequired : true,
                    label: this.$i18n.t("productType"),
                    // icon : '/img/delivery/store.png',
                    _classes: "text-left font-weight-normal ",
                },
                {
                    key: "shelfLife",
                    label: this.$i18n.t("shelfLife"),
                    _classes: "text-left font-weight-normal ",
                },
                {
                    key: "isOnScreen",
                    label: this.$i18n.t("isOnScreen"),
                    _classes: "text-center font-weight-normal ",
                },
                {
                    key: "favorite",
                    label: this.$i18n.t("favorite"),
                    _classes: "text-center font-weight-normal ",
                },
                {
                    key: "vatType",
                    label: this.$i18n.t("vatType"),
                    _classes: "text-center font-weight-normal ",
                },
                {
                    key: "isMenu",
                    label: this.$i18n.t("isMenu"),
                    _classes: "text-center font-weight-normal ",
                },
               
                {
                    key : 'actions',
                    _classes: "text-center font-weight-normal ",
                    label: this.$i18n.t(""),
                }
            ];
        },
        colorList() {
            let data = []
            for (let i = 0; i < 30; i++) {
                data.push({
                color: util.generateColor(i),
                value: i,
                })
            }
            return data
        },
   
        queryURL() {
            return (
                '?sort=' +
                this.sortdata +
                '&page=' +
                this.page +
                '&view=' +
                this.showView +
                '&searchBy=' +
                this.searchBy +
                '&keyword=' +
                this.keyword
            )
        },
        showView() {
        return this.$route.query.view || 'grid'
        },
        sortdata() {
            return this.$route.query.sort || 'SKUName'
        },
        page() {
            return this.$route.query.page || 1
        },
        searchBy() {
            return this.$route.query.searchBy || ''
        },
        keyword() {
            return this.$route.query.keyword || ''
        },
    },
    created() {
        this.getCategory();
        this.getUnit();
        this.startRow()
        this.shop = this.shops.find((i) => this.shopObjectId === i.objectId);
        if (this.shop) {
            this.isEcommercePage = this.shop.connectEcommerce;
        }
    },
    methods: {
        updateItem(index, key, value) {
            this.$set(this.items[index], key, value);
        },
        async handleDropImage(index, event) {
            event.preventDefault();
            event.stopPropagation();

            const dt = event.dataTransfer;
            if (!dt || !dt.files || !dt.files.length) {
                console.warn("No files found in dataTransfer");
                return;
            }

            const file = dt.files[0];
            if (!file.type.startsWith("image/")) {
                alert("กรุณาเลือกเฉพาะไฟล์รูปภาพเท่านั้น");
                return;
            }

            const reader = new FileReader();
            reader.onload = async (e) => {
                this.dragUploadIndex = index;
                const base64 = e.target.result;

                try {
                    const resized = await this.resizeImage(base64);
                    const remoteImagePath = await this.onUploadProductImage(this.items[index].objectId, resized);

                    this.$set(this.items[index], 'remoteImagePath', remoteImagePath); // ✅ This line was also incorrectly using `this.data` earlier
                } catch (error) {
                    console.error("Upload failed:", error);
                } finally {
                    this.dragUploadIndex = null;
                }
            };
            reader.readAsDataURL(file);
        },

        handleDrop(event) {
            event.preventDefault();
            event.stopPropagation();
            const file = event.dataTransfer.files[0];

            if (file && file.type.startsWith("image/")) {
                const reader = new FileReader();
                reader.onload = (e) => {
                this.imageDataBtn = e.target.result;
                this.isUpload = false;
                this.isload = true;
                this.$nextTick(() => {
                    if (this.$refs.cropper) {
                    this.$refs.cropper.replace(this.imageDataBtn);
                    }
                });
                };
                reader.readAsDataURL(file);
            } else {
                alert("กรุณาลากไฟล์รูปภาพเท่านั้น");
            }
            // หากต้องการให้ dragover มีเอฟเฟกต์สีขอบให้ใช้ @dragenter และ @dragleave เพื่อเพิ่ม / ลบคลาส dragover
        },
        setCropRatio(value) {      
            if (value === "freeform") {
                this.selectedRatio = NaN; // อัตราส่วนอิสระ
            } else if (value === "original") {
                const imageData = this.$refs.cropper.getImageData();
                this.selectedRatio = imageData.naturalWidth / imageData.naturalHeight; // คงอัตราส่วนเดิม
            } else {
                const [w, h] = value.split(":").map(Number); // แปลงค่า "3:2" -> [3, 2]
                this.selectedRatio = w / h;
            }
            this.cropperKey++;
        },
        async removeImage() {

        },
        savecolorimg() {
            this.loadingSaveimg = false
            if (this.isload) {
                let cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL()
                this.imageData = cropedImage
                this.getImageURL()
            } else {
                this.imageData = ''
                this.remoteImagePath = ''
                this.selectcolor = false
                this.loadingSaveimg = true
            }
        },
        async resizeImage(base64Str, maxWidth = 650, maxHeight = 500) {
            return new Promise((resolve) => {
                let img = new Image()
                img.src = base64Str
                img.onload = () => {
                let canvas = document.createElement('canvas')
                const MAX_WIDTH = maxWidth
                const MAX_HEIGHT = maxHeight
                let width = img.width
                let height = img.height

                if (width > height) {
                    if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width
                    width = MAX_WIDTH
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height
                    height = MAX_HEIGHT
                    }
                }
                canvas.width = width
                canvas.height = height
                let ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0, width, height)
                resolve(canvas.toDataURL())
                }
            })
        },
        async getImageURL() {
            let ref = this.itemObjectId
            if (this.$refs.cropper.getCroppedCanvas() === undefined) {
                return
            }

            const getCroppedCanvas = this.$refs.cropper.getCroppedCanvas().toDataURL()
            const resizedImage = await this.resizeImage(getCroppedCanvas)
            let ext = await mime.getExtension(resizedImage)
 
            if (ext == null) {
                alert('Only Support File Type Is JPEG, PNG')
                this.isload = false
            } else {
                const oldImagePath = this.imagePath
                // await uploadImage.deleteImage2(oldImagePath)
                const imageName = util.generateFilename('.' + ext)
                const ownerUID = `${localStorage.getItem('uid')}`
                const directoryPath = 'resources/' + ownerUID + '/resources/products/' + ref + '/' + imageName

                // this.remoteImagePath = await uploadImage.onUpload(ownerUID, ref, resizedImage, ext)
                let remoteImagePath = await this.onUploadProductImage(this.itemObjectId, resizedImage);
                // ตรวจสอบว่า selectedIndex มีค่าหรือไม่
                if (this.selectedIndex !== null && this.items[this.selectedIndex]) {
                    this.$set(this.items[this.selectedIndex], 'remoteImagePath', remoteImagePath);
                    // this.updateItem(this.selectedIndex, 'remoteImagePath', remoteImagePath);
                }
                this.imgTmpPath = remoteImagePath
                this.imagePath = directoryPath
                this.selectcolor = false
                this.loadingSaveimg = true
            }
        },
        async onUploadProductImage(ref, image) {
            let headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId)};
            let data = { ref, image };
            try {
                const res = await pos({
                method: 'POST',
                url: '/api/v3.0/upload/productimage',
                data,
                headers,
            });
                return res.data.data.publicUrl;
            } catch (error) {
                console.error('เกิดข้อผิดพลาดในการบันทึก:', error);
                return '';
            }
        },
        noImgUrl(event) {
            event.target.src = process.env.VUE_APP_NOIMAGE
        },
        goback() {
            this.$router.push('/product' + this.queryURL )
        },
        cancel() {
            if (this.remoteImagePath != undefined) {
                this.imageDataBtn = this.remoteImagePath
                this.selectcolor = false
                this.isUpload = true
                this.imageData = this.remoteImagePath
            }
            this.selectcolor = false
            this.isload = false
        },
        getBGColor(i){
            return util.generateColor(i)
        },
        setindexcolor(color) {

            if (this.selectedIndex !== null) {                
                this.items[this.selectedIndex].indexColor = color; // อัปเดตค่า indexColor ใน items
            }
            this.indexColor = color;
            this.selectcolor = false; // ปิด Modal หลังเลือกสี
        },
        getModalImg(item, index){
            if (item.remoteImagePath && item.remoteImagePath !== '') {
                this.imageData = item.remoteImagePath;
                this.imageDataBtn = item.remoteImagePath;
                this.remoteImagePath = item.remoteImagePath;
                this.$refs.cropper = item.remoteImagePath;
                // ตรวจสอบว่า VueCropper โหลดหรือยัง ก่อนเรียก methods หรือ properties ใน ref
                this.$nextTick(() => {
                    if (this.$refs.cropper) {
                        this.$refs.cropper.replace(item.remoteImagePath); // อัปเดตรูปภาพที่จะแสดงใน cropper
                    }
                });
            }else{
                this.remoteImagePath = '';
                this.imageData = '';
                this.imageDataBtn = '';
            }
            this.itemObjectId = item.objectId
            this.indexColor = item.indexColor
            this.selectedIndex = index; // เก็บ index ของรายการที่เลือก
            this.selectcolor = true
        },
        getUnit() {
            const uid = `${localStorage.getItem('shopsUid')}`
            let params = {
                page: 1,
                limit: 1000,
            }
            const shopObjectId = this.shopObjectId
            const headers = {
                shopObjectId: util.sanitizeShopObjectId(shopObjectId),
            }
            pos
                .get('/api/v1.0/uid/' + uid + '/Unit/data', { params, headers })
                .then((res) => {
                    this.unitlist = res.data.data
                    let data = this.unitlist
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].enabled === true) {
                            if (data[i].name == 'ชิ้น') {
                                this.unit = {
                                    id: data[i].id,
                                    name: data[i].name,
                                    objectId: data[i].objectId,
                                }
                                this.items[0].unit = this.unit
                            }
                        }
                    }
                })
        },
        getCategory() {
            const uid = `${localStorage.getItem('shopsUid')}`
            const shopObjectId = this.shopObjectId
            let params = {
                page: 1,
                limit: 1000,
            }
            const headers = {
                shopObjectId: util.sanitizeShopObjectId(shopObjectId),
            }

            pos.get('/api/v1.0/shop/' + uid + '/Category/data/' + shopObjectId, {
                params, headers
            }).then((res) => {
                this.categoryList = res.data.data
                const rows = Array.isArray(res.data.data) ? res.data.data : [];
                this.categoryList = rows.filter(c => String(c.id) !== '1')
                let data = this.categoryList

                for (let i = 0; i < data.length; i++) {
                    if (data[i].enabled === true) {
                        // set default to uncategory
                        if (data[i].id == '0') {
                            this.category = {
                                id: data[i].id,
                                name: data[i].name,
                                objectId: data[i].objectId,
                            }
                            this.items[0].category = this.category
                        }
                    }
                }
            })
        },
        async generateObjectId() {
            try {
            const uid = `${localStorage.getItem("shopsUid")}`;
            const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId)};

            const res = await pos({
                method: "get",
                headers: headers,
                url: "/api/v1.0/" + uid + "/objectId/generate",
            });

            return res.data.data.objectId;
            } catch (error) {
            console.error("Error generating objectId:", error);
            return null; // คืนค่า `null` หากเกิดข้อผิดพลาด
            }
        },
        async startRow(){
            this.errors =[]
            const maxItems = 5; // กำหนดจำนวนสูงสุด
            const currentItemCount = this.items.length;     
            this.items = []             
            // เพิ่มแถวตามจำนวนที่คำนวณได้
            for (let i = 0; i < 5; i++) {
                const objectId = await this.generateObjectId();
                this.items.push({
                    SKUName: "",
                    category: this.category,
                    enabled :  true,
                    favorite: false,
                    indexColor : 1,
                    isOnScreen :  true,
                    remoteImagePath : "",
                    shelfLife:  0,
                    skuType: "P",
                    vatType : "V",
                    unit: this.unit,
                    description: "",
                    PLUCode : "",
                    price: 0,
                    ratio: 1, //optional
                    isMenu : false,
                    objectId: objectId || util.generateObjectId()
                });
            }
            // แจ้งเตือนถ้าถึงจำนวนสูงสุด
            if (this.items.length >= maxItems) {
            console.warn("จำนวนแถวถึงขีดจำกัดสูงสุดแล้ว!");
            }
        },
        async addNewRow() {
            this.errors =[]
            const maxItems = 10; // กำหนดจำนวนสูงสุด
            const currentItemCount = this.items.length;            
            // ตรวจสอบว่าสามารถเพิ่มได้กี่แถว
            const rowsToAdd = Math.min(this.count, maxItems - currentItemCount);            
            // เพิ่มแถวตามจำนวนที่คำนวณได้
            for (let i = 0; i < rowsToAdd; i++) {
            const objectId = await this.generateObjectId();
            this.items.push({
                SKUName: "",
                category: this.category,
                enabled :  true,
                favorite: false,
                indexColor : 1,
                isOnScreen :  true,
                remoteImagePath : "",
                skuType: "P",
                vatType : "V",
                unit: this.unit,
                description: "",
                PLUCode : "",
                price: 0,
                ratio: 1, //optional
                isMenu : false,
                shelfLife: 0,
                objectId: objectId || util.generateObjectId()
            });
            }
            // แจ้งเตือนถ้าถึงจำนวนสูงสุด
            if (this.items.length >= maxItems) {
            console.warn("จำนวนแถวถึงขีดจำกัดสูงสุดแล้ว!");
            }
        },

        removeRow(index) {
            this.items.splice(index, 1);
        },

        addNewColumn() {
            const newKey = "col" + (this.dynamicColumns.length + 1);
            this.dynamicColumns.push({ key: newKey, label: "คอลัมน์ใหม่" });
            this.items.forEach(item => item[newKey] = ""); // เพิ่มข้อมูลคอลัมน์ให้กับทุกแถว
        },

        handleFileUpload(event, index) {
            const file = event.target.files[0];
            if (!file) return;

            const reader = new FileReader();
            reader.onload = (e) => {
                this.items[index].image = e.target.result;
            };
            reader.readAsDataURL(file);
        },

        async saveProducts() {
          
            if (this.validateFields()) {
                // console.log(this.errors);
                
                // console.warn("กรุณากรอกข้อมูลให้ครบทุกช่อง");
                this.isshowAlert = 5
                return;
            }
            this.items.forEach((item) => {
                 if (!item.PLUCode) {
                    item.PLUCode = util.generateBarcode(); // Assign the generated barcode
                }
                if(item.remoteImagePath == ""){
                    delete item.remoteImagePath;
                    delete item.objectId;
                    delete item.enabled
                }
                item.category = {
                    objectId : item.category.objectId,
                    id : item.category.id,
                    name : item.category.name
                }
                item.shelfLife = Number(item.shelfLife) || 0
            })
            let shopObjectId = this.shopObjectId;
            let headers = { shopObjectId: util.sanitizeShopObjectId(shopObjectId)}; 
            try {
                await  pos({
                    method: "POST",
                    url: "/api/v3.0/productsku/quick",
                    data: this.items,
                    headers: headers,
                })
                    .then((res) => {
                        console.log(res);
                        this.$router.push('/product' + this.queryURL )
                    })
                    .catch((error) => {
                    console.log(error);
                    });
            } catch (error) {
                console.error("เกิดข้อผิดพลาดในการบันทึก:", error);
            }
        },
        validateFields() {
            this.errors = []; // รีเซ็ต error ก่อนตรวจสอบใหม่

            this.items.forEach((item, index) => {
                this.errors[index] = {}; // สร้าง object errors ให้แต่ละแถว

                if (!item.SKUName) this.errors[index].SKUName = true;
                if (!item.category) this.errors[index].category = true;
                if (!item.unit) this.errors[index].unit = true;
                if (
                    item.price === '' ||
                    item.price === null ||
                    item.price === undefined ||
                    isNaN(item.price) ||
                    Number(item.price) < 0
                    ) {
                    this.errors[index].price = true;
                    } else {
                    this.errors[index].price = false;
                }
                if (!item.skuType) this.errors[index].skuType = true;
            });

            const hasErrors = this.errors.some(errorObj => 
                Object.values(errorObj).some(value => value === true)
            );

            return hasErrors // คืนค่า true ถ้าไม่มี error
        },
        uploadImage(e) {
            const file = e.target.files[0]

            if (typeof FileReader === 'function') {
                this.dialog = true

                const reader = new FileReader()
                reader.onload = (event) => {
                this.imageDataBtn = event.target.result
                this.$refs.cropper = this.imageData
                this.isUpload = false
                this.isload = true
                }
                reader.readAsDataURL(file)
            } else {
                alert('Sorry, FileReader API not supported')
            }
        },
    },
};
</script>
<style src="../../assets/styles/multiselect.css"></style>
<style scoped>
.position-relative {
    min-height: 400px;
    position: relative !important;
}

.custom-file-label i {
  font-size: 16px;
}
.color-picker-col {
  width: 31px; /* ปรับขนาดของปุ่ม */
  height: 31px;
  display: contents;
  justify-content: center;
  align-items: center;
  padding: 2px;
}

.color-picker-btn {
  /* width: 100%;
  height: 100%; */
  width: 26px; /* ปรับขนาดของปุ่ม */
  height: 26px;
  border-radius: 50%; /* ทำให้เป็นวงกลม */
  border: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.color-picker-btn.active {
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2); /* ขอบเงา */
  position: relative;
}

.selected-icon {
  color: white; /* สีของไอคอนถูกเลือก */
  font-size: 14px;
}
/* Container สำหรับ Input File */
.file-upload-container {
  display: flex;
  align-items: center;
  justify-content: left;
}

/* ซ่อน input file */
.file-upload-container input[type="file"] {
  display: none;
}

/* ปรับแต่งปุ่มอัปโหลด */
.custom-file-label {
  /* padding: 10px 20px; */
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 2px; /* ระยะห่างไอคอนกับข้อความ */
  transition: background-color 0.3s;
}

.custom-file-label:hover {
  /* background-color: #218838; */
}

/* ปรับขนาดไอคอน */
.custom-file-label i {
  font-size: 16px;
}
.color-picker-col {
  width: 31px; /* ปรับขนาดของปุ่ม */
  height: 31px;
  display: contents;
  justify-content: center;
  align-items: center;
  padding: 2px;
}

.color-picker-btn {
  /* width: 100%;
  height: 100%; */
  width: 26px; /* ปรับขนาดของปุ่ม */
  height: 26px;
  border-radius: 50%; /* ทำให้เป็นวงกลม */
  border: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.color-picker-btn.active {
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2); /* ขอบเงา */
  position: relative;
}

.selected-icon {
  color: white; /* สีของไอคอนถูกเลือก */
  font-size: 14px;
}
.drop-area {
  border: 2px dashed #ccc;
  border-radius: 10px;
  padding: 10px;
  transition: border 0.3s ease;
}

.drop-area.dragover {
  border-color: #29b289;
  background-color: #f9f9f9;
}
.display.dragover {
  border: 2px dashed #29b289;
  background-color: #f3fdfa;
  transition: 0.3s ease;
}
.dragover {
  border: 2px dashed #29b289;
  background-color: #e6f8f0;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
}
</style>